import {generalRequest} from "@/lib/services/requests";
import {useMutation, useQuery} from "@tanstack/react-query";

export const useApiSearchAdminTopics = (args) => {
    return useQuery({
        queryKey: ['admin', 'topic', 'search', args],
        queryFn: () => ((async (config = {}) => {
            return generalRequest.get(`/admin/topics`, {params: config});
        })(args)),
    })
}


export const useApiGetAdminTopics = (args) => {
    return useQuery({
        queryKey: ['admin', 'topic', 'get', args],
        queryFn: () => ((async (config = {}) => {
            return generalRequest.get(`/admin/topics/${config.id}`)
        })(args)),
    })
}


export function useApiCreateAdminTopicContent() {
    return useMutation({
        mutationFn: (data) =>
            ((async (config = {}) => {
                return generalRequest.post(`/admin/topics/${config.id}/contents`, config)
            })(data))
    });
}


export function useApiUpdateAdminTopicContent() {
    return useMutation({
        mutationFn: (data) =>
            ((async (config = {}) => {
                return generalRequest.put(`/admin/topics/${config.id}/contents/${config.topic_content_id}`, config)
            })(data))
    });
}


export function useApiDeleteAdminTopicContent() {
    return useMutation({
        mutationFn: (data) =>
            ((async (config = {}) => {
                return generalRequest.delete(`/admin/topics/${config.id}/contents/${config.topic_content_id}`)
            })(data))
    });
}
